import { ReactNode, createContext } from "react";
import useContaReceber, { ContaReceberType, CreateContaReceberType, UpdateContaReceberType, EfetuarBaixaReceberRequest } from "./hooks/useContaReceber";

interface ContaReceberContextProviderProps {
    children: ReactNode;
}

export interface ContaReceberContextData {
    getAllContaReceberPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        dataInicial?: string,
        dataFinal?: string,
        status?: number,
        codigoTransacao?: number,
        documento?: string,
        historico?: string,
        contaFinanceiraId?: number,
        categoriaFinanceiraId?: number,
        formaPagamentoId?: number
    ) => Promise<ContaReceberType[] | null>;
    setContaReceber: any;
    contaReceber: ContaReceberType;
    setListContaReceber: any;
    listContaReceber: ContaReceberType[];
    setInitialListContaReceber: any;
    initialListContaReceber: ContaReceberType[];
    setContaReceberPageCount: any;
    contaReceberPageCount: number;
    createContaReceber: (createContaReceberType: CreateContaReceberType) => Promise<CreateContaReceberType | null>;
    updateContaReceber: (updateContaReceberType: UpdateContaReceberType) => Promise<UpdateContaReceberType | null>;
    deleteContaReceber: (id: number) => Promise<ContaReceberType | null>;
    handleGetContaReceberByEmpresaId: (empresaId: number) => Promise<ContaReceberType[] | null>;
    listContaReceberByEmpresa: ContaReceberType[];
    setListContaReceberByEmpresa: any;
    efetuarBaixaContaReceber: (request: EfetuarBaixaReceberRequest) => Promise<boolean>;
    efetuarBaixaLoteContaReceber: (contaReceberIds: number[], dataBaixa: string) => Promise<boolean>;
    contaReceberTotalValor: number;
    setContaReceberTotalValor: (valor: number) => void;
}

const initialState: ContaReceberContextData = {
    getAllContaReceberPaged: async (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        dataInicial?: string,
        dataFinal?: string,
        status?: number,
        codigoTransacao?: number,
        documento?: string,
        historico?: string,
        contaFinanceiraId?: number,
        categoriaFinanceiraId?: number,
        formaPagamentoId?: number
    ) => {
        return Promise.resolve(null);
    },
    setContaReceber: () => { },
    contaReceber: {
        id: 0,
        valor: 0,
        taxa: 0,
        vencimento: "",
        dataEmissao: "",
        dataBaixa: "",
        documento: "",
        codigoTransacao: 0,
        historico: "",
        bandeira: "",
        status: 0,
        contaFinanceiraId: 0,
        contaFinanceiraName: "",
        categoriaFinanceiraId: 0,
        categoriaFinanceiraName: "",
        formaPagamentoId: 0,
        formaPagamentoName: "",
        numeroParcela: 1,
        totalParcelas: 1,
    },
    setListContaReceber: () => { },
    listContaReceber: [],
    setInitialListContaReceber: () => { },
    initialListContaReceber: [],
    setContaReceberPageCount: () => { },
    contaReceberPageCount: 0,
    createContaReceber: async (createContaReceberType: CreateContaReceberType) => {
        return Promise.resolve(null);
    },
    updateContaReceber: async (updateContaReceberType: UpdateContaReceberType) => {
        return Promise.resolve(null);
    },
    deleteContaReceber: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetContaReceberByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listContaReceberByEmpresa: [],
    setListContaReceberByEmpresa: () => { },
    efetuarBaixaContaReceber: async () => false,
    efetuarBaixaLoteContaReceber: async () => false,
    contaReceberTotalValor: 0,
    setContaReceberTotalValor: (valor: number) => { }
};

export const ContaReceberContext =
    createContext<ContaReceberContextData>(initialState);

export default function ContaReceberContextProvider({
    children,
}: ContaReceberContextProviderProps) {
    const {
        getAllContaReceberPaged,
        createContaReceber,
        updateContaReceber,
        deleteContaReceber,
        contaReceber,
        setContaReceber,
        setListContaReceber,
        listContaReceber,
        initialListContaReceber,
        setInitialListContaReceber,
        setContaReceberPageCount,
        contaReceberPageCount,
        handleGetContaReceberByEmpresaId,
        listContaReceberByEmpresa,
        setListContaReceberByEmpresa,
        efetuarBaixaContaReceber,
        efetuarBaixaLoteContaReceber,
        contaReceberTotalValor,
        setContaReceberTotalValor,
    } = useContaReceber();

    return (
        <ContaReceberContext.Provider
            value={{
                getAllContaReceberPaged,
                createContaReceber,
                updateContaReceber,
                deleteContaReceber,
                contaReceber,
                setContaReceber,
                setListContaReceber,
                listContaReceber,
                initialListContaReceber,
                setInitialListContaReceber,
                setContaReceberPageCount,
                contaReceberPageCount,
                handleGetContaReceberByEmpresaId,
                listContaReceberByEmpresa,
                setListContaReceberByEmpresa,
                efetuarBaixaContaReceber,
                efetuarBaixaLoteContaReceber,
                contaReceberTotalValor,
                setContaReceberTotalValor,
            }}
        >
            {children}
        </ContaReceberContext.Provider>
    );
}